<div class="card flex justify-content-center table-container app-resources-view">
  <p-table
    #dt1
    [value]="resources"
    [globalFilterFields]="globalFilterFields"
    dataKey="resourceArn"
    [scrollable]="true"
    [scrollHeight]="scrollHeight"
    [tableStyle]="{ 'min-width': '30rem' }"
    [showCurrentPageReport]="true"
    [styleClass]="'p-datatable-sm arp-prime-datatable'"
    [rowHover]="true"
    [totalRecords]="resources?.length"
    [paginator]="false"
    overflow="auto"
    selectionMode="single"
    [showLoader]="false"
    [loading]="loading"
    [rowTrackBy]="resourceTrackBy"
    [virtualScroll]="resources?.length > 3000"
    [virtualScrollItemSize]="45"
  >
    <ng-template pTemplate="loadingbody">
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="caption">
      <div class="flex-row">
        <div class="flex-bottom-row">
          <!-- showFailback-buttons from applications component html-->
          <ng-content select=".showFailback-buttons"></ng-content>
        </div>
        <span class="align-right flex-center-row">
          <p-iconfield class="filter-container">
            <input pInputText #filterInput type="text" (input)="filterGlobal($event)" placeholder="Filter..." />
            <p-inputicon
              *ngIf="!isFilterApplied && !loadingFilterInput"
              class="fa-utility-fill fa-semibold fa-filter fade-icon"
            />
            <p-inputicon
              *ngIf="isFilterApplied && !loadingFilterInput"
              (click)="clearInput(dt1)"
              class="fa-utility fa-semibold fa-xmark"
            />
            <p-inputicon *ngIf="loadingFilterInput" class="fa-solid fa-spinner fa-spin" />
          </p-iconfield>

          <div class="spacer"></div>
          <!--refresh-btn from applications component html-->
          <ng-content select=".refresh-btn"></ng-content>
        </span>
      </div>
    </ng-template>

    <!-- Header starts here -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="status" class="status-column strong-text">
          <div class="status-text strong-text">Status <p-sortIcon field="status"></p-sortIcon></div>
        </th>

        <th pSortableColumn="displayResourceType" placeholder="Type" class="resource-type-column">
          <div class="strong-text" style="margin-left: 7px">
            Resource Type <p-sortIcon field="displayResourceType"></p-sortIcon>
          </div>
        </th>

        <th
          *ngIf="shouldShowResourceGroupColumn && !appIsDeleted"
          pSortableColumn="sourceResourceGroup"
          class="table-column strong-text resource-group-column"
        >
          Resource Group
          <p-sortIcon field="sourceResourceGroup"></p-sortIcon>
        </th>
        <th *ngIf="!appIsDeleted" pSortableColumn="sourceResourceName" class="table-column strong-text name-column">
          Primary Resource
          <p-sortIcon field="sourceResourceName"></p-sortIcon>
        </th>

        <th pSortableColumn="targetResourceName" class="table-column strong-text name-column">
          Recovery Resource
          <p-sortIcon field="targetResourceName"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-resource>
      <tr>
        <td class="status-column-pill" [ngClass]="{ 'divider-row': !isExpandedRow(resource.resourceArn) }">
          <resource-status-pill [status]="resource.status" [progress]="resource.progress"></resource-status-pill>
        </td>
        <td class="resource-type-column" [ngClass]="{ 'divider-row': !isExpandedRow(resource.resourceArn) }">
          <span>{{ resource.displayResourceType }} </span>
        </td>
        <td
          *ngIf="shouldShowResourceGroupColumn && !appIsDeleted"
          class="no-starting-icon resource-group-column"
          [ngClass]="{ 'divider-row': !isExpandedRow(resource.resourceArn) }"
        >
          {{ resource.sourceResourceGroup || '' }}
        </td>
        <td
          *ngIf="!appIsDeleted"
          class="no-starting-icon"
          [ngClass]="{ 'divider-row': !isExpandedRow(resource.resourceArn) }"
        >
          {{ resource.sourceResourceName }}
          <a
            *ngIf="resource.sourceResourcePortalUri"
            [href]="resource.sourceResourcePortalUri"
            target="_blank"
            rel="noopener noreferrer"
            class="resource-portal-link"
            [title]="'View in ' + (resource.resourcePortalName || 'portal')"
          >
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </td>
        <td class="no-starting-icon" [ngClass]="{ 'divider-row': !isExpandedRow(resource.resourceArn) }">
          <div class="flex-center-row">
            <span class="spacer">
              {{ resource.targetResourceName }}
              <a
                *ngIf="resource.targetResourcePortalUri"
                [href]="resource.targetResourcePortalUri"
                target="_blank"
                rel="noopener noreferrer"
                class="resource-portal-link"
                [title]="'View in ' + (resource.resourcePortalName || 'portal')"
              >
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </a>
            </span>
            <span *ngIf="resource?.resourceProperties?.length > 0 || isS3Bucket(resource)">
              <button class="icon-button cursor-pointer" (click)="toggleRow(resource.resourceArn)">
                <i
                  class="fa-utility fa-semibold"
                  [ngClass]="{
                    'fa-angle-down': !isExpandedRow(resource.resourceArn),
                    'fa-angle-up': isExpandedRow(resource.resourceArn),
                  }"
                ></i>
              </button>
            </span>
          </div>
        </td>
      </tr>

      <tr *ngIf="isExpandedRow(resource.resourceArn)">
        <td class="divider-row"></td>
        <td class="divider-row" [attr.colspan]="appIsDeleted ? 2 : shouldShowResourceGroupColumn ? 4 : 3">
          <ng-container *ngIf="resource?.resourceProperties.length > 0">
            <!-- The real resource properties -->
            <div *ngFor="let prop of resource.resourceProperties">
              <span class="prop prop-name">{{ prop.name }}: </span>
              <span class="prop prop-val"
                >{{ prop.value }}
                <a class="copy-clipboard" [copy-clipboard]="prop.value">
                  &nbsp;<i class="fa-utility fa-semibold fa-copy copy-glyph"></i>
                </a>
              </span>
            </div>
          </ng-container>
          <div *ngIf="isS3Bucket(resource)">
            <!-- Synthetic property to display objectReplicationMode -->
            <span class="prop prop-name">Replication Mode: </span>
            <span class="prop prop-val">{{ s3ReplicationMode(resource) }}</span>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="paginatorleft">
      <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="summary">
      <div *ngIf="!loading" class="flex align-items-center justify-content-between">
        <ng-container *ngIf="dt1.value.length === 0">
          <span *ngIf="isFailbackTab; else recoveryEmptyState">
            No resources in this recovery point support failback.
          </span>
          <ng-template #recoveryEmptyState>
            <span
              >No resources found.
              <a [routerLink]="['configure']" fragment="application-resource-selection"
                >Select which resources to include in your application.</a
              ></span
            >
          </ng-template>
        </ng-container>
        <span *ngIf="dt1.value.length > 0"
          >Displaying {{ dt1.filteredValue?.length ?? dt1.value.length }} of {{ dt1.value.length }} resources.</span
        >
      </div>
    </ng-template>
  </p-table>
</div>
